// import { useContext } from 'react'
// import cookie from 'js-cookie'
// import { CoreContext } from 'contexts/coreContext'
import { logOutUserSelector, useUserStore } from 'store/userInfo.store'

const useLogOut = () => {
  // const { setCore } = useContext(CoreContext)
  const clearStore = useUserStore(logOutUserSelector)
  const logOut = () => {
    clearStore()
    // setCore({ user: { isLoggedIn: false } })
    // cookie.remove('token')
    // cookie.remove('user')
    // cookie.remove('approvedInformingId')
  }

  return { logOut }
}

export default useLogOut
